/**
 * 广外新闻任务---单独活动
 * 待我处理的活动
 */
import React, {Component} from 'react';
import ActivityPending from './NewActivityPending';
import {Tabs, Empty, Row, Col, message} from "antd";
import {formateData, headers} from "../../../../actions";
import {NAVIGATE_OPEN, NAVIGATE_CLOSE} from "../../../../constants";
import {connect} from "react-redux";
import {timeago, uuid} from "../../../../utils";
import {
    shrinNavigateStauts,
    updateNavigateLevel2Data
} from "../../../../actions";
import  moreImg from '../commImg/diandiandian.png';
const { TabPane } = Tabs;

class NewsTaskComponents extends Component {
    static defaultProps = {}
    static propTypes = {}

    ckqburl = "/interviewTask/interviewTask/1";
    nowType = 7;
    maxNum = 5;

    defaultHasAuthRoles = ["jsjz", "wzjz", "syjz", "sxjz","bj","zb","xsbj","xsjz"];
    isHasAuth = false;//是否有该组件的权限

    constructor(props) {
        super(props);
        this.props.currentUser.roleCodes && this.props.currentUser.roleCodes.map(item=>{
            if(this.defaultHasAuthRoles.indexOf(item) !== -1){
                this.isHasAuth = true;
            }
        })
        this.state = {
            num1:0,
            num2:0,
            list:[]
        }
    }

    componentWillMount() {
    }

    componentDidMount()
    {
        if(this.isHasAuth){
            this.callback(7);
            this.getInterView2Num();
        }
    }

    getInterView2Num()
    {
        getMyRemindByType(8, (data)=>{
            if(data && data.count)
            {
                this.setState({
                    num2 : data.count,
                })
            }
        });
    }

    readThisRemind(_id)
    {
        readRemind(_id, (data)=>{
            if(data === "true")
            {
                this.callback(this.nowType);
            }
        });
    }

    callback(interviewType)
    {
        this.setState({
            list : [],
        })
        this.nowType = interviewType;
        getMyRemindByType(interviewType, (data)=>{
            if(data && data.data)
            {
                let list = data.data;
                let dataList = [];
                let num1 = 0;
                {list.map((item, i)=>
                {
                    num1++;
                    if(i < this.maxNum)
                    {
                        if(item.interview)
                        {
                            let interView = item.interview;
                            let listObj = {};
                            listObj.id = interView.id;
                            listObj._id = item._id;
                            listObj.title = interView.title;
                            listObj.content = interView.content;
                            let endDate=interView.endDate.time;
                            let nowDate=new Date().getTime();

                            let statusMark = "未领取";
                            if(interView.status != 3 && endDate<nowDate){
                                statusMark = "已超期"
                            }else if(interView.status == 2)
                            {
                                statusMark = "进行中";
                            }else if(interView.status == 3){
                                statusMark = "已提交";
                            }

                            let otherMark= '（未处理）';
                            if(this.props.currentUser && this.props.currentUser.roleCodes.indexOf("bj") > -1){
                                    if(interView.interviewJointers){
                                        interView.interviewJointers.map(reports =>{
                                            if(reports.interviewRole == 5){
                                                otherMark ="（已处理）";
                                            }
                                        });
                                    }
                            }else if (this.props.currentUser && this.props.currentUser.roleCodes.indexOf("xsbj") > -1){
                                if(interView.interviewJointers){
                                    interView.interviewJointers.map(reports =>{
                                        if(reports.interviewRole == 1){
                                            otherMark ="（已处理）";
                                        }
                                    });
                                }
                            } else if (this.props.currentUser && this.props.currentUser.roleCodes.indexOf("xsjz") > -1){
                                    if(interView.status == 3){
                                        otherMark ="（已处理）";
                                    }
                            }else{
                                otherMark ='';
                            }
                            listObj.statusMark = statusMark+otherMark;
                            listObj.timeMark = interView.updateDate?timeago(interView.updateDate.time):timeago(interView.createDate.time);
                            dataList.push(listObj);
                        }
                    }
                })}

                if(interviewType == 7)
                {
                    this.ckqburl = "/interviewTask/interviewTask/1";
                    this.setState({
                        num1,
                        list : dataList
                    })
                }else {
                    this.ckqburl = "/interviewTask/interviewTask/2";
                    this.setState({
                        num2 : num1,
                        list : dataList
                    })
                }
            }
        });
    }

    findUrlData = (url)=>{
        let sons;
        let name;
        let stopFind = false;
        let find = (data, level, levelOneBrothers, levelOneName) => {
            if(stopFind)
                return;
            if((!data.sons || data.sons.length===0) && (!data.float_ || data.float_.length===0)){
                if(data.path === url){
                    sons = levelOneBrothers;
                    name = levelOneName;
                    stopFind = true;
                }
                return;
            }
            let tempSons = data.float_;
            if(!tempSons || tempSons.length === 0){
                tempSons = data.sons;
            }
            if(stopFind)
                return;
            tempSons && tempSons.map(item => {
                if(stopFind)
                    return;
                let tempItemSons = item.float_;
                if(!tempItemSons || tempItemSons.length === 0){
                    tempItemSons = item.sons;
                }
                if(level == 0){//取第一级的信息
                    find(item, level+1, tempItemSons, item.name);
                }else{
                    find(item, level+1, levelOneBrothers, levelOneName);
                }
            })
        };
        find({sons:this.props.navigateData},0, null, null);
        return {stopFind, sons, name};
    }

    gotoPage = (url)=>{
        let {stopFind, sons, name} = this.findUrlData(url);
        if(stopFind){
            this.props.shrinNavigateStauts();
            this.props.updateNavigateLevel2Data(name, sons);
            window.location.hash = url;
            return;
        }
        message.error("跳转失败！");
    }
    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    render() {
        if(!this.isHasAuth){
            return <div></div>
        }
        let menuWidth = parseInt(NAVIGATE_OPEN);
        if(!this.props.navigateStatus)
        {
            menuWidth = parseInt(NAVIGATE_CLOSE);
        }
        let dialogWidth = window.innerWidth;
        let layoutWidth = (((dialogWidth - menuWidth - 40 - 40 - 80)*0.55)/4);
        let minWidth = 170;
        if(layoutWidth <= minWidth)
        {
            layoutWidth = minWidth;
        }
        return (
            <div className={'ActivityPendingComponents StaticMyDeskItemPaddingTop'} style={{width: '100%'}}>

                <div style={{background: '#FFFFFF', position:'relative'}}>
                    <div style={{
                        height: 56,
                        lineHeight: '56px',
                        background: 'white',
                        width: '100%',
                        float: 'left',
                    }}>
                        <Tabs defaultActiveKey="7" onChange={(key)=>{this.callback(key)}}>
                            <TabPane tab={"新闻任务"+"("+this.state.num1+")"} key="7">
                            </TabPane>
                            {/*<TabPane  tab={"待我处理的选题"+"("+this.state.num2+")"} key="8">
                            </TabPane>*/}
                        </Tabs>
                        <div onClick={() => {
                            // window.location.hash = this.ckqburl;
                            this.gotoPage(this.ckqburl);
                        }} style={{
                            fontSize: 13,
                            right: 0,
                            color: '#0050B3',
                            float: 'right',
                            marginRight: 20,
                            cursor: 'pointer',position:'absolute',top:-7
                        }}>
                            <img src={moreImg} alt=""/>
                        </div>
                    </div>
                    <div style={{clear: 'both'}}/>
                    <div style={(()=>{
                        return this.state.list.length===0?{textAlign:'center',height:180}:{height:180}
                    })()}>
                        {
                            (()=>{
                                if(this.state.list.length===0){
                                    return <Empty/>;
                                }
                                let colCount = 4;
                                if(dialogWidth <= 1550)
                                {
                                    colCount = 3;
                                }
                                let rowCount = 1;
                                let rows = [];
                                let row;
                                this.state.list.map((item, index)=>{
                                    if(index <= rowCount * colCount - 1){
                                        if(index % colCount == 0){
                                            row = [];
                                            rows.push(row);
                                        }
                                        item.id = item.id?item.id:uuid();
                                        row.push(item);
                                    }
                                });
                                return rows.map((itemRow, index) => {
                                    return <Row key={index}>
                                        {itemRow.map(item =>{
                                            return <Col span={24/colCount} key={item.id?item.id:uuid()}>
                                                {/* <div key={i} style={{float: 'left'}}>*/}
                                                <ActivityPending
                                                    title={item.title}
                                                    iconType={2}
                                                    customWidth={layoutWidth}
                                                    content={item.content}
                                                    statusMark={item.statusMark}
                                                    timeMark={item.timeMark}
                                                    showPoint={true}
                                                    showX={true}
                                                    onClickItem={() => {
                                                        showDialog(item.id, item.title,item, ()=>{
                                                            this.callback(this.nowType);
                                                        });
                                                    }}
                                                    onRemoveItem={()=>{
                                                        this.readThisRemind(item._id);
                                                    }}
                                                />
                                            </Col>
                                        })}
                                    </Row>
                                })
                            })()
                        }
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state){
    return {
        navigateData: state.systemReducer.navigateData,
        navigateStatus:state.systemReducer.navigateStatus,
        currentUser: state.systemReducer.currentUser
    }
}

function mapStateToMethod(dispatch) {
    return {
        shrinNavigateStauts: function () {
            return dispatch(shrinNavigateStauts());
        },
        updateNavigateLevel2Data: function (title, data) {
            return dispatch(updateNavigateLevel2Data(title, data));
        }
    }
}

export default connect(mapStateToProps, mapStateToMethod)(NewsTaskComponents);

export const getMyRemindByType = (type, callBack)=> {
    let url = "/cm-sites-pms/remind/getMyRemindByType";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({type})
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getMyRemindByType",error);
        callBack("");
    })
}

export const readRemind = (_id, callBack)=> {
    let url = "/cm-sites-pms/remind/read";
    fetch(url, {
        method: 'post',
        cache: 'no-cache',
        headers: headers,
        credentials: 'include',
        body: formateData({_id})
    }).then(response => response.text()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:readRemind",error);
        callBack("");
    })
}

function showDialog(interviewId, interviewName,data, endFun)
{
    window.layer.open({
        id: "weibo",
        btn: null,
        type: 2,//0（信息框，默认）1（页面层）2（iframe层）3（加载层）4（tips层）。
        content: "/cm-sites/pms/interviewTask/interviewTaskdetail.html?interviewId=" + interviewId,
        title : interviewName,
        resize : true,
        shade : 0.001,	//遮罩
        //shade : 0,
        //shadeClose : true,	//点击遮罩是否关闭
        zIndex : 100,
        area: [parseInt(window.$(window).width() * 0.9) + 'px',parseInt(window.$(window).height() * 0.9) + 'px'],
        success:function(layero, index){
            var body = window.layer.getChildFrame('body',index);
        },
        end: function () {
            if(endFun){
                endFun();
            }
        }
    })
}
//修改
function update1(interviewId,interviewType,interviewName,endFun){
    let checkReportData = {};//每次新增采访任务时，将之前选择的记者清除
    window.openFull("/cm-sites/pms/interviewTask/interviewTaskadd.html?interviewId="+interviewId + "&interviewType="+interviewType, interviewName, function(){
        window.interviewlistFrame = window;
    }, {
        btn: ['确定', '关闭'],
        type: 2,//0（信息框，默认）1（页面层）2（iframe层）3（加载层）4（tips层）。
        resize : false,
        shade:0.5,
        area: [parseInt(window.$(window).width() * 0.9) + 'px',parseInt(window.$(window).height() * 0.9) + 'px'],
        zIndex : 100,
        yes : function(index, layero) {
            window.layer.close(index);
            if(endFun){
                endFun();
            }
        }
    });

}